import { render, staticRenderFns } from "./provider.vue?vue&type=template&id=3464f760"
import script from "./provider.vue?vue&type=script&lang=js"
export * from "./provider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports